import { TABLE_ROW_CHROME_HOST_ATTRIBUTE } from './dom/table-row-chrome';

export const HTML_VISUAL_EDITOR_STYLE_ATTRIBUTE = 'data-html-template-visual-editor';

export const serializeDoctype = (doctype: DocumentType | null): string => {
    if (!doctype) return '';

    const publicId = doctype.publicId ? ` PUBLIC "${doctype.publicId}"` : '';
    const systemId = doctype.systemId ? `${doctype.publicId ? '' : ' SYSTEM'} "${doctype.systemId}"` : '';
    return `<!DOCTYPE ${doctype.name}${publicId}${systemId}>\n`;
};

const stripEditorOnlyNodes = (root: ParentNode, editorStyleAttribute: string): void => {
    root.querySelectorAll(`[${editorStyleAttribute}]`).forEach((element) => element.remove());
    // Table row hover chrome (⋮ + menu buttons) must never persist into saved HTML.
    root.querySelectorAll(`[${TABLE_ROW_CHROME_HOST_ATTRIBUTE}]`).forEach((element) => element.remove());
};

const stripCollapsedFormatArtifacts = (root: ParentNode): void => {
    const walker = root.ownerDocument?.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes: Text[] = [];
    let node = walker?.nextNode();
    while (node) {
        textNodes.push(node as Text);
        node = walker?.nextNode();
    }
    textNodes.forEach((textNode) => {
        if (!textNode.data.includes('\u200B')) return;
        textNode.data = textNode.data.split('\u200B').join('');
        if (textNode.data === '') textNode.remove();
    });

    root.querySelectorAll('strong, b, em, i, u').forEach((element) => {
        if ((element.textContent ?? '') !== '' || element.querySelector('img, br, hr, video, svg')) return;
        element.remove();
    });
};

export const serializeEditedHtml = (document: Document, serializesFullDocument: boolean, editorStyleAttribute = HTML_VISUAL_EDITOR_STYLE_ATTRIBUTE): string => {
    const html = document.documentElement.cloneNode(true) as HTMLElement;
    stripEditorOnlyNodes(html, editorStyleAttribute);
    stripCollapsedFormatArtifacts(html);

    const body = html.querySelector('body');
    body?.removeAttribute('contenteditable');
    body?.removeAttribute('spellcheck');

    if (!serializesFullDocument) {
        return body?.innerHTML ?? '';
    }

    return `${serializeDoctype(document.doctype)}${html.outerHTML}`;
};
